import React from 'react';

import FormRow from '../../../app/components/FormRow';
import DynamicTextarea from '../../../app/components/DynamicTextarea';
import { CreateUpdateProjectWithTeamDto } from '../../../common/pokCore/autogenerated/pokApiClient/models';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ProjectApplicationFormProps {
  project: CreateUpdateProjectWithTeamDto;
  readOnly?: boolean;
  showDateChangeForm?: boolean;
  propertyChange?: (obj: Partial<CreateUpdateProjectWithTeamDto>) => void;
}

export const ProjectApplicationForm: React.FC<
  ProjectApplicationFormProps
> = props => {
  const { t, tk } = useTranslation('projectLng');
  const message = props.showDateChangeForm
    ? t(tk.prLang.errEditProjectSendApplication)
    : t(tk.prLang.errCreateProjectSendApplication);
  return (
    <>
      <ValidationAlert show={true} errors={[message]} className="m-3" />
      <FormRow
        controlId="applicationMessage"
        label={t(tk.projects.applicationContent)}
      >
        {props.showDateChangeForm ? (
          <DynamicTextarea
            value={props.project?.dateChangeMessage || ''}
            onChange={e =>
              props.propertyChange &&
              props.propertyChange({ dateChangeMessage: e.target.value })
            }
            readOnly={props.readOnly}
          />
        ) : (
          <DynamicTextarea
            value={props.project?.delayMessage || ''}
            onChange={e =>
              props.propertyChange &&
              props.propertyChange({ delayMessage: e.target.value })
            }
            readOnly={props.readOnly}
          />
        )}
      </FormRow>
    </>
  );
};
